import React, {useState, useEffect} from 'react'
import _ from '/home/ps/root'
import vw from '/home/ps/view/view'
import { Ref, timer } from '../../../global'
export const ID = 'toast'
// https://www.digitalocean.com/community/tutorials/react-modal-component
const styleContent = content => content.reduce((acc, c, i) => {
  // acc.push(<p key={i}>{c}</p>)
  acc.push(<div key={i}>{c}</div>)
  return acc
}, [])
let ToasterSetState
export const Toaster = prop => {
  const [state, _setState] = useState({response: ['Confirm', 'Cancel'], show: false, content: styleContent(['Modal', 'Data'])})
  const {display, position, content, show, response} = state
  const setState = s => {
    if (s.content) s.content = styleContent(s.content)
    _setState(_s => ({..._s, ...s}))
  }
  ToasterSetState = setState
  const style = {
    display: show ? 'initial' : 'none',
    position: position || 'fixed',
    // position:'absolute',
    backgroundColor: 'azure',
    width: '80%',
    border: `5px solid ${vw.THEME}`,
    borderRadius: '5px',
    // zIndex: 6,
    zIndex: 13,
  }
  useEffect(() => {
    const el = document.getElementById(ID)
    el.style.left = '50px'
    el.style.top = '200px'
    // document.getElementById(ID).scroll
  })
  const p = {state, setState, style}
  return <main><Modal {...p}>{content}</Modal></main>
}
Toaster.ID = ID
export default Toaster

export const Toast = prop => {
  const _prop=Ref.store.getState().master
  const master=_prop.init.master.response
  const connected = Ref.socket.connected
  const {
    response = [master.yes.i, master.no.i],
    content = 'Nothing provided',
    callback = e => console.log({ID, e}, 'null callback'),
  } = prop
  ToasterSetState({show: true, response, content, callback: r => {
    // callback(r == response[0])
    // debugger
    callback(response.length>2 ? r : (r==response[0]))
  }})
}
export const toast = msg => Toast({response: ['Ok'], content: [msg]})
const Modal = prop => {
  const {state, style, children, setState} = prop
  const styleModal={textAlign: 'center', margin: '7px'}
  const [modal, _setModal] = useState({timerId: null, wait: ''})
  const {timerId, wait} = modal
  const setModal = s => _setModal(_s => ({..._s, ...s}))
  const clearTimer = e => {
    if (timerId) clearInterval(timerId)
    setModal({wait: '', timerId: null})
    setState({show: false})
  }
  useEffect(() => {
    if (state.show) {
      if (state.response.length==1 && !timerId) {
        const timerId = timer(r => setModal({wait: r}), 60, 0, f => clearTimer(f))
        // setModal({timerId, wait: 'min'})
        setModal({timerId})
      }
    } else {
      if (timerId) clearInterval(timerId)
      setModal({timerId: null, wait: ''})
    }
  }, [state.show])
  const onClick = (e, response) => {
    e.stopPropagation()
    e.preventDefault()
    state.callback(response)
    clearTimer()
  }
  return (
    <div style={style} id={ID}>
      <section style={styleModal}>
        <div style={{textAlign: 'right', color: 'red'}}>{wait}</div>
        {children}
        <div style={{...styleModal, textAlign: 'right'}}>
        {
          state.response.reduce((acc, r)=>{
            switch (r) {
              case 'select': debugger
              // default: acc.push(<button key={r} onClick={e=>onClick(e, r)} style={{...styleModal, minWidth: '60px'}}>{r}</button>)
              default: acc.push(<input type='button' key={r} onClick={e => onClick(e, r)} style={{...styleModal, minWidth: '60px'}} value={r}/>)
            }
            return acc
          }, [])
        }
        </div>
      </section>
    </div>
  )
}
